const stickyHeader = () => {
	document.body.classList.toggle('page-scrolled', window.pageYOffset !== 0);
};

export default stickyHeader;
